import { FaqItem, CustomerReview } from '../types/store';

export interface CategoryItem {
  id: string;
  name: string;
  slug: string;
  tagline: string;
  description: string;
  iconName: string;
  color: string;
}

export const SHOP_BY_NEEDS: CategoryItem[] = [
  {
    id: 'weight-gain',
    name: 'Weight Gain',
    slug: 'weight-gain',
    tagline: 'Healthy Mass & Bulk',
    description: 'Nutrition products designed to support healthy weight gain.',
    iconName: 'TrendingUp',
    color: 'from-amber-500/10 to-amber-600/20',
  },
  {
    id: 'daily-nutrition',
    name: 'Daily Nutrition',
    slug: 'daily-nutrition',
    tagline: 'Everyday Vitality',
    description: 'Balanced nutrition products for everyday wellness.',
    iconName: 'HeartPulse',
    color: 'from-emerald-500/10 to-emerald-600/20',
  },
  {
    id: 'energy-strength',
    name: 'Energy & Strength',
    slug: 'energy-strength',
    tagline: 'Power & Stamina',
    description: 'Nutrition products for active lifestyles and daily energy.',
    iconName: 'Zap',
    color: 'from-blue-500/10 to-blue-600/20',
  },
  {
    id: 'supplements',
    name: 'Supplements',
    slug: 'supplements',
    tagline: 'Vital Minerals & Vitamins',
    description: 'Explore our health and nutrition supplements.',
    iconName: 'ShieldCheck',
    color: 'from-indigo-500/10 to-indigo-600/20',
  },
];

export const FAQS: FaqItem[] = [
  {
    id: 'faq-1',
    question: 'What is the delivery time?',
    answer: 'Orders are usually delivered within 2–5 working days across Pakistan. Major metropolitan cities (Karachi, Lahore, Islamabad, Rawalpindi) typically receive delivery within 48 to 72 hours.',
  },
  {
    id: 'faq-2',
    question: 'Do you offer Cash on Delivery?',
    answer: 'Yes, Cash on Delivery (COD) is available across Pakistan. You pay the delivery rider in cash only after receiving your parcel safely at your doorstep.',
  },
  {
    id: 'faq-3',
    question: 'What are the shipping charges?',
    answer: 'Free shipping is available on orders above Rs. 2,000. For orders below Rs. 2,000, a flat standard delivery fee of Rs. 200 PKR applies nationwide.',
  },
  {
    id: 'faq-4',
    question: 'Can I return my order?',
    answer: 'Returns are accepted according to the store\'s return policy. Customers should contact support via WhatsApp or email if an order arrives damaged or incorrect within 7 days of delivery for a prompt replacement or refund.',
  },
  {
    id: 'faq-5',
    question: 'How can I contact Health Store?',
    answer: 'Contact Health Store through WhatsApp or the contact information provided in the footer. Our customer support team is available Monday through Saturday from 9:00 AM to 9:00 PM PKT.',
  },
];

export const CUSTOMER_REVIEWS: CustomerReview[] = [
  {
    id: 'rev-1',
    author: 'Muhammad Hamza',
    city: 'Lahore',
    rating: 5,
    date: '2 days ago',
    productName: 'MalRich Healthy Weight Gain Milk Powder',
    flavor: 'Vanilla',
    reviewText: 'Zabardast product hai! 100% original tin received hua with seal pack. Taste is super creamy in warm milk, and I gained 2.5 kg in 3 weeks without any heavy stomach feeling.',
    verifiedBuyer: true,
    avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80',
    reviewImage: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&auto=format&fit=crop&q=80',
    likesCount: 24,
    featured: true,
  },
  {
    id: 'rev-2',
    author: 'Ayesha Tariq',
    city: 'Karachi',
    rating: 5,
    date: '3 days ago',
    productName: 'MalRich Mango Balanced Diet Supplement',
    flavor: 'Mango',
    reviewText: 'Ordered for my kids and family. Mango flavour is so natural and refreshing with chilled milk. TCS parcel arrived within 48 hours at Gulshan-e-Iqbal, Karachi. Highly recommended store!',
    verifiedBuyer: true,
    avatarUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&auto=format&fit=crop&q=80',
    reviewImage: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&auto=format&fit=crop&q=80',
    likesCount: 19,
    featured: true,
  },
  {
    id: 'rev-3',
    author: 'Bilal Ahmed Khan',
    city: 'Islamabad',
    rating: 5,
    date: '5 days ago',
    productName: 'MalRich Weight Gain — Chocolate',
    flavor: 'Chocolate',
    reviewText: 'Rich chocolate milkshake taste! Best supplement for gym recovery and stamina. No lumps while mixing in shaker. Cash on Delivery was completely hassle-free.',
    verifiedBuyer: true,
    avatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80',
    reviewImage: 'https://images.unsplash.com/photo-1579722821273-0f6c7d44362f?w=600&auto=format&fit=crop&q=80',
    likesCount: 31,
    featured: true,
  },
  {
    id: 'rev-4',
    author: 'Zainab Fatima',
    city: 'Rawalpindi',
    rating: 5,
    date: '1 week ago',
    productName: 'MalRich Buy 2 Get 1 Free Family Bundle',
    flavor: 'Strawberry',
    reviewText: 'Got the 3-tin special bundle pack with Free Shipping. Packing was top notch with bubble wrap. Original company tin with long expiry. Very satisfied with Health Store service!',
    verifiedBuyer: true,
    avatarUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&auto=format&fit=crop&q=80',
    reviewImage: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&auto=format&fit=crop&q=80',
    likesCount: 42,
    featured: true,
  },
  {
    id: 'rev-5',
    author: 'Usman Farooq',
    city: 'Faisalabad',
    rating: 5,
    date: '1 week ago',
    productName: 'MalRich Healthy Weight Gain Milk Powder',
    flavor: 'Vanilla',
    reviewText: 'Best quality nutrition powder in Pakistan. Genuine product, helpful customer support on WhatsApp, and quick delivery. Already ordered my 2nd tin.',
    verifiedBuyer: true,
    avatarUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80',
    reviewImage: 'https://images.unsplash.com/photo-1526947425960-945c6e72858f?w=600&auto=format&fit=crop&q=80',
    likesCount: 15,
    featured: true,
  },
  {
    id: 'rev-6',
    author: 'Dr. Kashif Rehman',
    city: 'Peshawar',
    rating: 5,
    date: '2 weeks ago',
    productName: 'MalRich Balanced Diet Supplement',
    flavor: 'Mango',
    reviewText: 'Very well balanced nutrient profile with Magnesium, Zinc, and multivitamins. Safe and gentle for everyday energy support. Authentic store with verified COD.',
    verifiedBuyer: true,
    avatarUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&auto=format&fit=crop&q=80',
    reviewImage: 'https://images.unsplash.com/photo-1583947215259-38e31be8751f?w=600&auto=format&fit=crop&q=80',
    likesCount: 28,
    featured: true,
  },
  {
    id: 'rev-7',
    author: 'Sana Farhan',
    city: 'Multan',
    rating: 5,
    date: '2 weeks ago',
    productName: 'MalRich Weight Gain — Strawberry',
    flavor: 'Strawberry',
    reviewText: 'Strawberry flavor is so yummy! My underweight daughter started having it twice a day and her energy and appetite have improved noticeably. Thank you Health Store!',
    verifiedBuyer: true,
    avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80',
    reviewImage: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=600&auto=format&fit=crop&q=80',
    likesCount: 21,
    featured: true,
  },
];

export const PAKISTANI_CITIES = [
  'Karachi',
  'Lahore',
  'Islamabad',
  'Rawalpindi',
  'Faisalabad',
  'Multan',
  'Peshawar',
  'Quetta',
  'Sialkot',
  'Gujranwala',
  'Hyderabad',
  'Bahawalpur',
  'Sargodha',
  'Abbottabad',
  'Sukkur',
  'Jhelum',
  'Mardan',
  'Sheikhupura',
  'Wah Cantt',
  'Rahim Yar Khan',
  'Other City',
];

export const BLOG_POSTS = [
  {
    id: 'blog-1',
    title: 'Top 5 Nutrients Required For Natural Healthy Weight Gain',
    excerpt: 'Discover why a balance of Magnesium, Zinc, high-quality proteins and complex carbohydrates is essential for healthy mass.',
    category: 'Nutrition Guide',
    date: 'August 12, 2026',
    readTime: '4 min read',
    author: 'Health Store Wellness Team',
  },
  {
    id: 'blog-2',
    title: 'How MalRich Balanced Diet Supports Your Family Daily Energy',
    excerpt: 'A complete breakdown of essential vitamins A, B-Complex, C, and D3 for immune defense and sustained vitality in Pakistan.',
    category: 'Health & Wellness',
    date: 'August 08, 2026',
    readTime: '5 min read',
    author: 'Dr. Shahida R. (Nutritionist)',
  },
  {
    id: 'blog-3',
    title: 'Delicious MalRich Smoothie Recipes: Vanilla, Mango & Choco Bliss',
    excerpt: 'Fun, tasty ways to incorporate your daily MalRich scoop into high-calorie, healthy breakfast smoothies and post-workout bowls.',
    category: 'Recipes',
    date: 'July 29, 2026',
    readTime: '3 min read',
    author: 'Chef Adeel & Nutrition Desk',
  },
];
